<template>
  <div></div>
</template>

<script>
import authService from '@/services/authService';

export default {
  data() {
    return {};
  },
  created() {
    authService.logout();
  },
  methods: {}
};
</script>
